<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'personal-userMaterialAbnormal',
  components: {
    PageTable,
  },
}
</script>
